import find from 'lodash/find';
import findLast from 'lodash/findLast';
import flatMap from 'lodash/flatMap';
import uniq from 'lodash/uniq';
import { ActionTypes } from '../../actions/index';
import { Level, PriceTypePrice } from '../../classes/level';
import { IAppState } from '../../reducers/index';
import { fetchSeatMatches, setBlankSeatMatchResponse } from './filter-fetch';


export function clearPriceRange(minPrice: number, maxPrice: number) {
    return (dispatch, state) => {
        dispatch({ type: ActionTypes.PRICE_RANGE_CLEAR, value: { minPrice: minPrice, maxPrice: maxPrice } });
        dispatch(fetchSeatMatches());
    }
}

export function selectMinPrice(minPrice: number) {
    return (dispatch, state) => {
        const priceRangeResult = findPriceRange(state, minPrice, false);

        dispatch({ type: ActionTypes.SELECT_MIN_PRICE, value: minPrice });
        dispatch(handlePriceRangeChangeResult(priceRangeResult));
    };
}

export function selectMaxPrice(maxPrice: number) {
    return (dispatch, state) => {
        const priceRangeResult = findPriceRange(state, maxPrice, true);

        dispatch({ type: ActionTypes.SELECT_MAX_PRICE, value: maxPrice });
        dispatch(handlePriceRangeChangeResult(priceRangeResult));
    };
}

function handlePriceRangeChangeResult(priceRangeResult: IPriceRangeChangeResult) {
    return (dispatch, state) => {
        if (!priceRangeResult.includesValidPrices) {
            dispatch(setBlankSeatMatchResponse());
        }
        else if (priceRangeResult.hasChanged) {
            dispatch(fetchSeatMatches());
        }
    }
}

interface IPriceRangeChangeResult {
    hasChanged: boolean;
    includesValidPrices: boolean;
}
/*TODO: filter by selected price types */
function getSortedPriceAmounts(levels: Level[]): number[] {
    const priceTypePrices: PriceTypePrice[] = flatMap(levels, a => a.priceTypePrices);

    const uniquePrices: number[] = uniq(priceTypePrices.flatMap(pt => { return pt.price + pt.feeAmount }));
    const sortedPrices = uniquePrices.sort((a, b) => { return a - b });
    return sortedPrices;
}
function findPriceRange(state, newPrice: number, isMaxPrice: boolean): IPriceRangeChangeResult {
    const currentState: IAppState = state();
    const sortedPrices = getSortedPriceAmounts(currentState.appSettingsModel.venueLevels);
    const lastMaxPricePoint = findLast(sortedPrices, price => { return price <= currentState.priceRangeModel.maxPrice });
    const lastMinPricePoint = find(sortedPrices, price => { return price >= currentState.priceRangeModel.minPrice });

    let hasChanged = true;
    let includesValidPrices = true;

    if (isMaxPrice) {        
        const currentMaxPricePoint = findLast(sortedPrices, price => { return price <= newPrice });

        hasChanged = lastMaxPricePoint !== currentMaxPricePoint;
        includesValidPrices = find(sortedPrices, price => { return price <= currentMaxPricePoint && price >= lastMinPricePoint }) !== undefined;
            
    } else {        
        const currentMinPricePoint = find(sortedPrices, price => { return price >= newPrice });

        hasChanged = lastMinPricePoint !== currentMinPricePoint;
        includesValidPrices = find(sortedPrices, price => { return price <= lastMaxPricePoint && price >= currentMinPricePoint }) !== undefined;
    }

    return { hasChanged, includesValidPrices };
}